import { configurationTheme } from "../../environment/index";

let theme = configurationTheme;

export default theme;